import { applyMiddleware, compose, createStore } from 'redux'
import { routerMiddleware } from 'connected-react-router'
import createSagaMiddleware from 'redux-saga'

import createRootReducer from './rootReducer'
import history from './history'
import rootSaga from './rootSaga'

const enhancedCompose =
  process.env.NODE_ENV === 'development'
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
    : compose

export const sagaMiddleware = createSagaMiddleware()

// connected router is here to enable full time travel debugging, including location changes
const store = createStore(
  createRootReducer(history),
  enhancedCompose(applyMiddleware(routerMiddleware(history), sagaMiddleware)),
)

sagaMiddleware.run(rootSaga)

export default store
